



























































import BaseComponent from "@/asdcom/BaseComponent";
import { StaffNotificationSubscriptionDto, UserNotification, UserNotificationState, EntityDtoOfGuid } from '@/asdcom/apiproxy/apiproxy.dto';
import {Component} from "vue-property-decorator";
import bus from "@/components/vcponlineok/bus/bus.js";
import { IHeader } from "@/store/models/staff/IHeader";

@Component({})
export default class Notifications extends BaseComponent {
  notifications: UserNotification[] = [];
	page: number = 1;
	notifPerPage: number = 10;
	paginationLength: number = 0;
	filter: string = "";
	headers: IHeader[] = [
		{ text: "Name", value: "notification.notificationName", sortable: true },
		{ text: "Message", value: "notification.data.properties.Message", sortable: true },
		{ text: "Date", value: "notification.creationTime", sortable: true }
	]

	created() {
		this.refreshNotifications();
	}

	mounted() {
    bus.$on('refreshList', () => {
      this.refreshNotifications();
    })
  }

  beforeDestroy() {
    bus.$off('refreshList');
  }

	get visibleNotifications() {
		return this.notifications.slice((this.page - 1)*this.notifPerPage, this.page*this.notifPerPage);
	}

	async refreshNotifications() {
		const res = await this.$appsvs.notifications.getUserNotifications(undefined, undefined, undefined, 1000, 0);
		this.notifications = res.items || [];

		if (!!this.notifications) {
			this.paginationLength = Math.ceil(this.notifications.length / this.notifPerPage);
		}
	}

	isDataExchangeNotification(notifType: string) {
		if (notifType == "DataExchangeError_Email" || notifType == "DataExchangeError") {
			return true;
		} else { return false; }
	}

	boldText(state: number) {
    if (state == UserNotificationState.Unread) {
      return 'font-weight-bold'
    }
  }

	async markNotificationAsRead(item: UserNotification) {
		if (item.state == UserNotificationState.Unread) {
			const input = {id: item.id} as EntityDtoOfGuid;
			this.$appsvs.notifications.setNotificationAsRead(input)
			.then(() => {
				this.refreshNotifications();
			})
		}
	}
}
